import { Plan, PlanStep, PlanStepLink } from '@core/models/plan.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { planActions } from './plan.actions';

export const planFK = 'planModule';

export interface PlanState {
  plan: Partial<Plan>;
  steps: EntityState<PlanStep>;
  links: EntityState<PlanStepLink>;
}

export const planStepsAdapter: EntityAdapter<PlanStep> = createEntityAdapter<PlanStep>();
export const planLinksAdapter: EntityAdapter<PlanStepLink> = createEntityAdapter<PlanStepLink>();

export const planInitialState: PlanState = {
  plan: {},
  steps: planStepsAdapter.getInitialState(),
  links: planLinksAdapter.getInitialState()
};

const planReducer = createReducer(
  planInitialState,
  on(planActions.stepsAndLinksLoaded, (state, { plan, steps, links }) => ({
    ...state,
    plan,
    steps: planStepsAdapter.setAll(steps, state.steps),
    links: planLinksAdapter.setAll(links, state.links),
    mode: 'edit'
  })),

  // plan
  on(planActions.saved, (state, { plan }) => ({ ...state, plan })),
  on(planActions.removed, () => planInitialState),

  // step
  on(planActions.stepAdded, (state, { step }) => ({ ...state, steps: planStepsAdapter.addOne(step, state.steps) })),
  on(planActions.stepUpdated, planActions.stepMoved,
    (state, { step }) => ({
      ...state, steps: planStepsAdapter.updateOne(
        { id: step.id as number, changes: step }, state.steps)
    })),
  on(planActions.stepDeleted, (state, { id }) => ({ ...state, steps: planStepsAdapter.removeOne(id, state.steps) })),

  // link
  on(planActions.linkAdded, (state, { link }) => ({ ...state, links: planLinksAdapter.addOne(link, state.links) })),
  on(planActions.linkDeleted, (state, { childId, parentId }) => {
    const id = Object.values(state.links.entities).find(l => l?.childId === childId && l.parentId === parentId)?.id;
    return id ? { ...state, links: planLinksAdapter.removeOne(id, state.links) } : state;
  })
);

export function reducer(state: PlanState | undefined, action: Action) {
  return planReducer(state, action);
}
